// shared/footer/footer.js
import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2023 Safety Zone. جميع الحقوق محفوظة.</p>
        <div className="footer-links">
                  <a href="tel:+201028510553" >اتصل بنا</a>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;